import React, { useState } from "react";
import styled, { css } from "styled-components";
import {
    Button,
    StandardModalSectionTitle,
    portalColors
} from "src/components";

import SmsIcon from "../img/new/sms.svg";
import EmailIcon from "../img/new/email.svg";
import SmsIconGreen from "../img/new/sms-green.svg";
import EmailIconGreen from "../img/new/email-green.svg";

const RadioButton = styled(Button)`
    border: 1px solid ${p => p.active ? "#36BE24" : portalColors.inputBorder};
    color: ${p => p.active ? "#36BE24" : portalColors.text};
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px !important;
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: 500;
    width: 14.25rem;
    height: 49px;
    background-color: ${p => p.active ? "#E6FFE3" : portalColors.surfaceSoft};
    box-shadow: ${portalColors.inputShadow};

    ${props => props.active && 
        css`
            color: #36BE24;
            border: 1px solid #36BE24;
            background-color: #E6FFE3;
        `
}
    ${props => props.disabled && 
        css`
            color: #36BE24;
            border: 1px solid #36BE24;
            background-color: #E6FFE3;
        `
}
`;

const ButtonIcon = styled.img`
    width: 20px;
    height: auto;
    margin-right: 6px;

    [data-theme="dark"] button:not([data-active="true"]) & {
        filter: brightness(0) invert(1);
        opacity: 0.9;
    }
`;

const SelectedLabel = styled.div`
    text-align: center;
    font-size: 12px;
    color: #36BE25;
    margin-top: 10px;
`;

const InviteMethodOptions = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;
`;

const AppInviteMethod = ({ setAppInviteMethod, noTitle }) => {
    const [selectedMethod, setSelectedMethod] = useState("email");

    const handleSwitchMethod = (value) => {
        setSelectedMethod(value);
        setAppInviteMethod(value);
    };

    return (
        <div>
            {!noTitle && <StandardModalSectionTitle>Select App Invite Method</StandardModalSectionTitle>}
            <InviteMethodOptions>
                <div>
                    <input type="radio" name="sendMethod" value="email" style={{ visibility: "hidden" }} />
                    <RadioButton active={selectedMethod === "email"} data-active={selectedMethod === "email"} onClick={() => handleSwitchMethod("email")}>
                        <ButtonIcon src={selectedMethod === "email" ? EmailIconGreen : EmailIcon} />
                        Send Invite By Email
                    </RadioButton>
                    {selectedMethod === "email" && <SelectedLabel>Selected</SelectedLabel>}
                </div>
                <div>
                    <input type="radio" name="sendMethod" value="sms" style={{ visibility: "hidden" }} />
                    <RadioButton active={selectedMethod === "sms"} data-active={selectedMethod === "sms"} onClick={() => handleSwitchMethod("sms")}>
                        <ButtonIcon src={selectedMethod === "sms" ? SmsIconGreen : SmsIcon} />
                        Send Invite By SMS
                    </RadioButton>
                    {selectedMethod === "sms" && <SelectedLabel>Selected</SelectedLabel>}
                </div>
                <div>
                    <input type="radio" name="sendMethod" value="both" style={{ visibility: "hidden" }} />
                    <RadioButton active={selectedMethod === "both"} data-active={selectedMethod === "both"} onClick={() => handleSwitchMethod("both")}>
                        <ButtonIcon src={selectedMethod === "both" ? EmailIconGreen : EmailIcon} />
                        <ButtonIcon src={selectedMethod === "both" ? SmsIconGreen : SmsIcon} />
                        Send Both
                    </RadioButton>
                    {selectedMethod === "both" && <SelectedLabel>Selected</SelectedLabel>}
                </div>
            </InviteMethodOptions>
        </div>
    );
};

export default AppInviteMethod;
